import React, { useEffect, useState } from "react";
import classNames from 'classnames';
import GoogleMap from "../../../../../components/common/GoogleMap";
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import { GoogleMapsProvider } from "../../../../../providers/GoogleMapsProvider";
import { Button, Card, Col, ProgressBar, Row, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import IconButton from "../../../../../components/common/IconButton";
//import GoogleMapRoutes from '../../../../../components/common/google-maps-advance/GoogleMapsRoutes';
import { decryptData, encryptTextToBase64Url, segundosATiempo, obtenerLinkMapa } from "../../../../../helpers/utils";
import { ReporteRecorridoService } from "../../../../../services/apiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { QURO_GPS_CONFIG, QURO_MAP_CONFIG } from '../../../../../config/apiConfig'
import { useRecorridosStore } from '../../../../../lib/store/recorridos.store'
import dayjs from "dayjs";
import GoogleMapSelector from "../../../../../components/common/google-maps-selector/GoogleMapSelector";
import { jwtDecode } from "jwt-decode";


const coloresProfesionales = {
  movimiento: '#008001',  // Indigo moderno
  apagado: '#db8049',     // Gris neutro
  detenido: '#ffcb05'     // Amber profesional
};

const stylesCSS = `
  .progress-professional {
    background: linear-gradient(145deg, #f1f5f9, #e2e8f0);
    border-radius: 12px;
    box-shadow: 
      0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
    overflow: hidden;
    position: relative;
  }
  
  .progress-bar-professional-manual {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
  }
  
  .cursor-pointer {
    cursor: pointer;
  }
  
  .min-width-0 {
    min-width: 0;
  }
  
  /* ✅ ESTILOS PARA TOOLTIP PERSONALIZADO */
  .custom-tooltip .tooltip-inner {
    background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .custom-tooltip .tooltip-arrow::before {
    border-top-color: #1f2937;
  }
  
  .fs-12 {
    font-size: 11px;
  }
  
  .fs-10 {
    font-size: 10px;
  }
`;
export default function RecorridosMap({ data, resumenUnidad }) {

  const [selectedLocation, setSelectedLocation] = React.useState({ lat: null, lng: null });
  const [selectedLocations, setSelectedLocations] = React.useState([]); // Todas las rutas del mapa
  const [dataResumenUnidad, setDataResumenUnidad] = useState([])
  const [totalHorasUso, setTotalHorasUso] = useState('')
  const [tokenQuro, setTokenQuro] = useState('')
  const [hoveredSegment, setHoveredSegment] = useState(null);

  const filtroRecorrido = useRecorridosStore((state) => state.filtro)

  const calcularCentroPromedio = (locations) => {
    const latSum = locations.reduce((sum, loc) => sum + loc.lat, 0);
    const lngSum = locations.reduce((sum, loc) => sum + loc.lng, 0);
    return {
      lat: latSum / locations.length,
      lng: lngSum / locations.length,
    };
  };

  // **Agrupar por número económico y extraer no_ecomomico**
  const vehiculoAgrupado = data.length > 0 ? '' + data[0].vehiculos.noEconomico + ' / ' + data[0].vehiculos.alias : "Desconocido";
  const vehiculoidreport = data.length > 0 ? data[0].vehiculoId : 0;
  const vehiculoUidreport = data.length > 0 ? data[0].vehiculoUid : 0;
  // **Obtener ubicaciones de data (latitud y longitud)**
  const markers = data
    .filter(item => item.latitud !== null && item.longitud !== null) // Evita valores nulos
    .map(item => ({
      lat: item.latitud,
      lng: item.longitud
    }));

  //Crear objeto resumen de unidad

  useEffect(() => {

    const _arreglo = []

    _arreglo.push({
      orden: 1,
      nombre: 'Movimiento',
      tiempo: segundosATiempo(resumenUnidad.tiempo_movimiento + resumenUnidad.tiempo_actividad),
      valor: resumenUnidad.tiempo_movimiento + resumenUnidad.tiempo_actividad,
      color: coloresProfesionales.movimiento,//'#2770e9'
    })
    _arreglo.push({
      orden: 2,
      nombre: 'Detenido',
      tiempo: segundosATiempo(resumenUnidad.tiempo_detenido),
      valor: resumenUnidad.tiempo_detenido,
      color: coloresProfesionales.detenido,//'#ff771e'
    })

    _arreglo.push({
      orden: 3,
      nombre: 'Apagado',
      tiempo: segundosATiempo(resumenUnidad.tiempo_apagado),
      valor: resumenUnidad.tiempo_apagado,
      color: coloresProfesionales.apagado,//'#728095'
    })




    const totalResumenUnidadcom = resumenUnidad.tiempo_movimiento +
      resumenUnidad.tiempo_actividad +
      resumenUnidad.tiempo_apagado +
      resumenUnidad.tiempo_detenido;

    // console.log("🔧 [TOTAL CORREGIDO] Verificación:", {
    //   tiempo_movimiento: resumenUnidad.tiempo_movimiento,
    //   tiempo_actividad: resumenUnidad.tiempo_actividad,
    //   tiempo_apagado: resumenUnidad.tiempo_apagado,
    //   tiempo_detenido: resumenUnidad.tiempo_detenido,
    //   total_calculado: totalResumenUnidad,
    //   suma_valores_array: dataResumenUnidad.reduce((sum, item) => sum + item.valor, 0),
    //   coinciden: totalResumenUnidad === dataResumenUnidad.reduce((sum, item) => sum + item.valor, 0)
    // });

    const totalHrsUso = segundosATiempo(totalResumenUnidadcom);
    setTotalHorasUso(totalHrsUso)
    setDataResumenUnidad(_arreglo)

  }, [resumenUnidad])

  const totalResumenUnidad = resumenUnidad.tiempo_movimiento + resumenUnidad.tiempo_actividad + resumenUnidad.tiempo_apagado + resumenUnidad.tiempo_detenido;

  // **Cálculos de distancia, velocidad y tiempo**
  const totalDistancia = data.reduce((sum, item) => sum + (item.distancia || 0), 0).toFixed(2); // Convertido a km

  const calcularVelocidadPromedio = () => {

    const velocidades = []

    data.forEach(p => {

      if ((p.tipo === 1 || p.tipo == 2 || p.tipo === 4 || p.tipo == 6) && p.tipoMotor == 1) {

        velocidades.push(p.velocidad);
      } else if ((p.tipo === 3 || p.tipo == 5) && p.tipoMotor == 0) {

        velocidades.push(p.velocidad);
      }
    });

    const promVel =
      velocidades.length > 0
        ? (velocidades.reduce((sum, item) => sum + item, 0) / velocidades.length).toFixed(2)
        : 0; // Evitar división por 0

    return promVel
  }

  const velocidadPromedio = calcularVelocidadPromedio();

  /*const totalHorasUso = velocidadPromedio > 0
    ? (totalDistancia / velocidadPromedio).toFixed(2)
    : 0;*/

  // **Función para manejar la visualización del mapa**
  const handleShowMap = (markers) => {

    if (markers) {
      if (markers.length > 0) {
        setSelectedLocation({ lat: markers[0].lat, lng: markers[0].lng });
        setSelectedLocations(markers);
      }
    }
  };

  // **Cargar las ubicaciones automáticamente al montar el componente**
  useEffect(() => {
    if (markers.length > 0) {
      handleShowMap(markers);
    }
  }, [data]); // Se actualiza si cambia la data

  const obtenerTokenQuro = async () => {

    const response = await ReporteRecorridoService.getTokenConexionQuro()
    if (response && response.statusCode === 200) {

      if (response.data != null && response.data.length != 0) {
        setTokenQuro(response.data)
      } else {

        setTokenQuro('')
      }

    }
  }

  const handleClickAbrirRecorrido = () => {

    obtenerTokenQuro()
  }

  useEffect(() => {

    if (tokenQuro.length > 0) {

      const _fechaCargaInicial = dayjs(filtroRecorrido.fechaInicial).format('YYYY-MM-DDTHH:mm:ss')
      const _fechaUltimaCarga = dayjs(filtroRecorrido.fechaFinal).format('YYYY-MM-DDTHH:mm:ss')

      const _redirect = `Uid=${vehiculoUidreport}&fecha_carga_inicia=${_fechaCargaInicial}&Fecha_Ultima_Carga=${_fechaUltimaCarga}`

      const mapUrl = obtenerLinkMapa(_redirect, QURO_MAP_CONFIG.BASE_URL);

      if (mapUrl) {
        window.open(mapUrl);
      }
    }
  }, [tokenQuro])

  const style = {
    display: "-webkit-box",
    WebkitLineClamp: 1, // Limita a 2 líneas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
  };

  return (

    <div className="h-100" style={{ backgroundColor: 'white', borderRadius: '0.375rem' }}>
      <Card>
        <FalconCardHeader
          title={
            <div style={style} title={`${vehiculoAgrupado || "No disponible"}`}>
              {vehiculoAgrupado || "No disponible"}
            </div>
          }
          light
          titleTag="h6"
          endEl={
            <div>   <Button
              variant="outline-primary"
              size="sm"
              style={{
                backgroundColor: 'white',
                color: '#2c7be5'
              }}
              onClick={handleClickAbrirRecorrido}
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} /> Abrir recorrido
            </Button> </div>
          }
        />
      </Card>
      <div className="p-2 position-relative" >
        <Row className="mb-2 mt-2 g-0 flex-nowrap">
          <Col md={4} xs={4} className="p-0">
            <Row style={{ margin: 0, padding: 0 }}> {/* Elimina márgenes y relleno */}
              <Col md={12} style={{ padding: 0 }}> {/* Quita el padding de la columna */}
                <h5 className="text-center">{totalHorasUso} hr(s)</h5>
              </Col>
              <Col md={12} className="d-flex justify-content-center" style={{ padding: 0 }}>
                <span className="fs-10 label-normal text-truncate label-normal" >
                  Total horas de uso
                </span>

              </Col>
            </Row>
          </Col>
          <Col md={4} xs={4}>
            <Row>
              <Col md={12}>
                <h5 className="text-1100 text-center">{totalDistancia} km</h5>
              </Col>
              <Col md={12} className="d-flex justify-content-center">
                {/* <h6 className="text-center fw-light">Distancia recorrida</h6> */}
                <span className="fs-10 label-normal text-truncate label-normal" >
                  Distancia recorrida
                </span>

              </Col>
            </Row>
          </Col>
          <Col md={4} xs={4}>
            <Row>
              <Col md={12} >
                {/*VELOCIDAD PROMEDIO  data.velocidad   convertido a kilometros/h*/}
                <h5 className="text-1100 text-center">{velocidadPromedio} km/h</h5>
              </Col>
              <Col md={12} className="d-flex justify-content-center">
                {/* <h6 className="text-center fw-light">Velocidad promedio</h6> */}

                <span className="fs-10 label-normal text-truncate label-normal" >
                  Velocidad promedio
                </span>

              </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{ height: '240px' }}>
          <Col md={12}>
            {selectedLocation.lat && selectedLocation.lng ? (
              <GoogleMapSelector
                zoomDefault={11}
                initialCenter={calcularCentroPromedio(selectedLocations)}
                waypoints={selectedLocations}
                showStreetView={false}
                markers={selectedLocation}
                mapStyle="hoper"
              />
            ) : (
              <p>Ubicación no disponible</p>
            )}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={12}>
            <Row className="flex-nowrap">
              {
                dataResumenUnidad.map((item, index) => {
                  const porcentaje = ((item.valor * 100) / totalResumenUnidad).toFixed(0);

                  // ✅ TOOLTIP PARA EL LABEL
                  const renderLabelTooltip = (props) => (
                    <Tooltip id={`label-tooltip-${item.orden}`} {...props} className="custom-tooltip">
                      <div className="text-center">
                        <strong className="text-white">{item.nombre}</strong><br />
                        <span className="fs-12 text-light">Tiempo completo: {item.tiempo}</span><br />
                        <span className="fs-12 text-light">Porcentaje: {porcentaje}%</span>
                      </div>
                    </Tooltip>
                  );

                  return (
                    <Col xs={4} key={item.orden}>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 300, hide: 200 }}
                        overlay={renderLabelTooltip}
                      >
                        <div
                          className="d-flex align-items-center cursor-pointer"
                          style={{
                            padding: '2px 4px',
                            borderRadius: '4px',
                            transition: 'all 0.2s ease',
                            backgroundColor: hoveredSegment === item.orden ? 'rgba(0,0,0,0.05)' : 'transparent'
                          }}
                          onMouseEnter={() => setHoveredSegment(item.orden)}
                          onMouseLeave={() => setHoveredSegment(null)}
                        >
                          <span
                            className="dot flex-shrink-0"
                            style={{
                              backgroundColor: item.color,
                              width: hoveredSegment === item.orden ? 12 : 10,
                              height: hoveredSegment === item.orden ? 12 : 10,
                              borderRadius: '50%',
                              display: 'inline-block',
                              marginRight: 6,
                              transition: 'all 0.2s ease',
                              boxShadow: hoveredSegment === item.orden ? `0 0 8px ${item.color}50` : 'none'
                            }}
                          ></span>

                          <div className="flex-grow-1 min-width-0 position-relative"> {/* Contenedor relativo */}
                            <div className="d-flex flex-column w-100 pe-4"> {/* Espacio para el porcentaje */}
                              <div className="d-flex justify-content-between align-items-center">
                                <strong className="fs-11 label-normal text-truncate" style={{ maxWidth: '70%' }}>
                                  {item.nombre}
                                </strong>
                              </div>
                              <div className="fs-11 text-muted text-truncate label-normal">
                                {item.tiempo}
                              </div>
                            </div>
                            {/* Porcentaje posicionado absolutamente (no afecta el layout) */}
                            <span
                              className="fs-10 label-bold position-absolute end-0"
                              style={{
                                top: "50%",
                                transform: "translateY(-50%)",

                              }}
                            >
                              {porcentaje}%
                            </span>
                          </div>

                          {/* <div className="flex-grow-1 min-width-0">
                            <div className="d-flex justify-content-between align-items-center">
                              <Form.Check.Label className="label-bold ps-2 fs-11  mb-0  w-100 d-flex justify-content-between">
                                {item.nombre}
                                <div className="">{porcentaje}%</div>
                              </Form.Check.Label>

                            </div>
                            <div className="fs-10 text-muted text-truncate">
                              <Form.Check.Label className="label-bold  fs-11 mb-0">
                                {item.tiempo}
                              </Form.Check.Label>

                            </div>
                          </div> */}

                        </div>
                      </OverlayTrigger>
                    </Col>
                  );
                })
              }
            </Row>

            <style dangerouslySetInnerHTML={{ __html: stylesCSS }} />

            <div
              className="progress-professional mb-3"
              style={{
                height: 15,
                display: 'flex',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              {
                dataResumenUnidad.map((item, index) => {
                  const porcentajeProgress = (item.valor * 100) / totalResumenUnidad;

                  if (porcentajeProgress <= 0 || isNaN(porcentajeProgress)) {
                    return null;
                  }

                  // ✅ TOOLTIP PARA LA BARRA
                  const renderProgressTooltip = (props) => (
                    <Tooltip id={`progress-tooltip-${item.orden}`} {...props} className="custom-tooltip">
                      <div className="text-center">
                        <div className="d-flex align-items-center justify-content-center mb-1">
                          <span
                            className="dot me-2"
                            style={{
                              backgroundColor: item.color,
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              display: 'inline-block'
                            }}
                          ></span>
                          <strong className="text-white">{item.nombre}</strong>
                        </div>
                        <div className="fs-12 text-light opacity-90">
                          ⏱️ Tiempo: <span className="fw-bold">{item.tiempo}</span>
                        </div>
                        <div className="fs-12 text-light opacity-90">
                          📊 Porcentaje: <span className="fw-bold">{porcentajeProgress.toFixed(1)}%</span>
                        </div>
                      </div>
                    </Tooltip>
                  );

                  // ✅ DETERMINAR SI ESTÁ RESALTADO
                  const isHighlighted = hoveredSegment === item.orden;

                  return (
                    <OverlayTrigger
                      key={item.orden}
                      placement="top"
                      delay={{ show: 200, hide: 300 }}
                      overlay={renderProgressTooltip}
                    >
                      <div
                        style={{
                          backgroundColor: item.color,
                          width: `${porcentajeProgress}%`,
                          height: '100%',
                          cursor: 'pointer',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          position: 'relative',
                          borderRadius: index === 0 ? '12px 0 0 12px' :
                            index === dataResumenUnidad.length - 1 ? '0 12px 12px 0' : '0',
                          // ✅ RESALTADO SINCRONIZADO
                          filter: isHighlighted ? 'brightness(1.2) saturate(1.2)' : 'brightness(1)',
                          transform: isHighlighted ? 'scaleY(1.1)' : 'scaleY(1)',
                          zIndex: isHighlighted ? 10 : 1,
                          boxShadow: isHighlighted ? `0 0 12px ${item.color}80` : 'none'
                        }}
                        className="progress-bar-professional-manual"
                        onMouseEnter={() => setHoveredSegment(item.orden)}
                        onMouseLeave={() => setHoveredSegment(null)}
                      >
                        {/* ✅ EFECTO DE BRILLO */}
                        <div
                          style={{
                            content: '',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '50%',
                            background: 'linear-gradient(180deg, rgba(255,255,255,0.2) 0%, transparent 100%)',
                            pointerEvents: 'none'
                          }}
                        />

                        {/* ✅ INDICADOR DE SELECCIÓN */}
                        {isHighlighted && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '-2px',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              width: '6px',
                              height: '6px',
                              backgroundColor: item.color,
                              borderRadius: '50%',
                              border: '2px solid white',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}
                          />
                        )}
                      </div>
                    </OverlayTrigger>
                  );
                })
              }
            </div>


          </Col>
        </Row>
      </div>



    </div>

  );
}
